
/**
 * Loader API Version: 2
 * Is this in "webpack mode": true
 */
export default {
  "title": "Help Center",
  "support": "For setup guidance and support articles, please visit the ",
  "supportLink": "Privacy Hero Support Center",
  "setup": "Need help with setup or troubleshooting? ",
  "setupLink": "Contact Support"
}
